// extracted by mini-css-extract-plugin
export default {"closeXButton":"CloseXButton_closeXButton__noon-"};